import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import store, { persistor } from "./store/store";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import { PersistGate } from "redux-persist/integration/react";

import { PrimeReactProvider } from "primereact/api";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter as Router } from "react-router-dom";

import { Provider } from "react-redux";
import Login from "./views/Login/Login";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GoogleAuthClientID || ""}
    >
      <PrimeReactProvider>
        <Router>
          <PersistGate loading={<Login />} persistor={persistor}>
            <React.StrictMode>
              <App />
            </React.StrictMode>
          </PersistGate>
        </Router>
      </PrimeReactProvider>
    </GoogleOAuthProvider>
  </Provider>
);
